import { LoadingSpinnerIcon } from '../Icons';
import { Heading } from '../Typography';
import { Card } from './Card';
import { IconHeadingWrapper, StyledValueCard } from './styles';

interface ValueCardProps extends React.ComponentPropsWithoutRef<typeof Card> {
    heading: string;
    headingId: string;
    icon?: React.ReactNode;
    loading?: boolean;
    value: string;
}

export const ValueCard = ({
    heading,
    headingId,
    icon,
    loading = false,
    value,
    children,
    ...otherProps
}: ValueCardProps) => {
    return (
        <StyledValueCard aria-labelledby={headingId} {...otherProps}>
            <IconHeadingWrapper>
                {icon && icon}
                <Heading id={headingId} level={3}>
                    {heading}
                </Heading>
            </IconHeadingWrapper>
            <Heading level={2}>{loading || !value ? <LoadingSpinnerIcon /> : value}</Heading>
            {children}
        </StyledValueCard>
    );
};
